import AutoComplete from '@tarekraafat/autocomplete.js';
import { EVENT_TYPES } from 'shared';
import AutocompleteConfig from './config';
import AutocompleteSelectors from './selectors';
// import Konami from './konami';
import toggleAnimatedPlaceholder from './animated_placeholder';
import { appendArtistSearchOption } from './artist_search';
import { keyboardNavigationHandler, mouseEventHandler, togglePlaceholder } from './navigation_helpers';
import { appendCaliforniaDataCollectionNotice, saveSearch, removeSearch } from './search_history';

const allAutocompletes = AutocompleteSelectors.map(({ searchSelector, resultSelectors }) => {
  let autoCompleteHandler;

  try {
    // Only configure autocomplete for a search box if it is present on the current page.
    const searchInputElement = document.querySelector(`#${searchSelector}`);
    if(!searchInputElement) return;

    const defaultConfig = AutocompleteConfig(searchSelector, resultSelectors);

    const isAnimated = document.querySelector(defaultConfig.selector).dataset.animated;
    defaultConfig.placeHolder = isAnimated ? '' : 'Search all designs';

    const searchFormElement = searchInputElement.closest('form');
    const searchDataHiddenField = searchFormElement.querySelector('.jsAutoCompleteData');
    const clearSearchButton = searchFormElement.querySelector('.jsClearHeaderSearch');

    autoCompleteHandler = new AutoComplete(defaultConfig);

    // Add listener for Konami Code !!!
    // new Konami(searchInputElement).init();

    ['focus', 'blur', 'input'].forEach(function (eventType) {
      searchInputElement.addEventListener(eventType, function () {
        const resultsListElement = document.getElementById(autoCompleteHandler.resultsList.idName);

        togglePlaceholder(this.value);

        if (!resultsListElement) return;

        if (eventType === 'blur') {
          resultsListElement.style.display = 'none';
        } else {
          resultsListElement.style.display = 'block';
        }
      });
    });

    searchInputElement.addEventListener('open', function(event) {
      const resultsList = event.target.nextElementSibling;
      const dataFeedback = event.detail;
      const inputValue = dataFeedback.input;

      // Prepend 'trending' label if we have any trending results
      const resultListEl = document.getElementById(autoCompleteHandler.resultsList.idName);

      if (resultListEl) {
        const items = Array.from(resultListEl.children);
        let hasInsertedRecentLabel = false;
        let hasInsertedTrendingLabel = false;

        items.forEach((item) => {
          if (item.classList.contains('recent-search') && inputValue.length === 0 && !hasInsertedRecentLabel) {
            const label = document.createElement('div');
            label.id = 'jsRecentSearchLabel';
            label.className = 'autoComplete_label';
            label.textContent = 'Recent Searches';
            resultListEl.insertBefore(label, item);
            hasInsertedRecentLabel = true;
          } else if (item.classList.contains('trending') && !hasInsertedTrendingLabel) {
            const label = document.createElement('div');
            label.id = 'jsTrendingSearchLabel';
            label.className = 'autoComplete_label';
            label.textContent = 'Trending Searches';
            if (hasInsertedRecentLabel) {
              // Autocomplete.js builds the list items. Writing styles here
              // allows us to modify the elements without having to modify the library.
              label.style.marginTop = '1.6rem';
            }
            resultListEl.insertBefore(label, item);
            hasInsertedTrendingLabel = true;
          }

          // Add x_close icon to the recent search items
          if (item.classList.contains('recent-search')) {
            const closeIcon = document.createElement('span');
            closeIcon.setAttribute('aria-label', 'Clear search');
            closeIcon.className = 'jsAutocompleteClear';
            closeIcon.innerHTML = searchInputElement.dataset.searchHistoryClear
            closeIcon.style.float = 'right';
            // Add the clock icon on the left side of the recent search item
            if (inputValue.length > 0) {
              const clockIcon = document.createElement('span');
              clockIcon.setAttribute('aria-label', 'Recent search');
              clockIcon.innerHTML = searchInputElement.dataset.searchHistoryClock;
              clockIcon.style.float = 'left';
              clockIcon.style.paddingRight = '5px';
              item.insertBefore(clockIcon, item.firstChild);
            }
            closeIcon.addEventListener('click', function(event) {
              event.preventDefault();
              event.stopPropagation();
              const searchValue = item.textContent;
              removeSearch(searchValue);
              item.remove();
              const recentSearcheslabel = document.getElementById('jsRecentSearchLabel');
              if (resultListEl.querySelectorAll('.recent-search').length === 0) {
                recentSearcheslabel.remove();
                const trendingLabel = document.getElementById('jsTrendingSearchLabel');
                if (trendingLabel) {
                  trendingLabel.style.marginTop = '0';
                }
              }
            });
            item.appendChild(closeIcon);
          }
        });
      }

      appendArtistSearchOption(resultsList, inputValue);
      appendCaliforniaDataCollectionNotice(resultListEl, searchInputElement);
      mouseEventHandler(event, autoCompleteHandler);
    })

    searchInputElement.addEventListener('navigate', event => {
      const resultsList = event.target.nextElementSibling;
      const dataFeedback = event.detail;
      const inputValue = dataFeedback.input;

      // Append artist search option if shopper has navigated thruough the list before
      // the "open" event has triggered.
      appendArtistSearchOption(resultsList, inputValue);

      keyboardNavigationHandler(event, autoCompleteHandler);
      togglePlaceholder(event.target.value);
    })

    // Additional event listener to handle when user submit without interact with AutoComplete suggestions
    searchInputElement.addEventListener('keydown', event => {
      if (event.keyCode === 13) {
        // Prevent AutoComplete.js to throw an error on submit non-autocomplete term
        if (event.target.getAttribute('aria-activedescendant') === null) {
          event.stopImmediatePropagation();
        }

        if (event.target.value !== '') searchFormElement.submit();
      }
    })

    searchFormElement.addEventListener(EVENT_TYPES.SUBMIT, function (e) {
      e.preventDefault();
      toggleAnimatedPlaceholder('hide');

      let usedAutocomplete = searchInputElement.dataset.submitted === 'true',
        feedback,
        selection;
      if (searchInputElement.dataset.feedback !== undefined) {
        feedback = JSON.parse(searchInputElement.dataset.feedback);
        selection = feedback.selection;
      }

      // attaches search data to hidden form element
      searchDataHiddenField.value = JSON.stringify({usedAutocomplete, feedback, selection, searchInputId: searchInputElement.id, searchInputValue: searchInputElement.value});

      const artistSearchValue = searchFormElement.querySelector('.jsArtistSearchData').value;
      if (searchInputElement.dataset.searchHistory === 'true' && artistSearchValue !== 'true') {
        saveSearch(searchInputElement.value);
      }
      searchFormElement.submit();
    });

    // CLEAR SEARCH BUTTON
    clearSearchButton.addEventListener('click', function (e) {
      e.preventDefault();
      toggleAnimatedPlaceholder('show');
      searchInputElement.value = '';
      searchInputElement.focus();
    });

  } catch (e) { }

  return autoCompleteHandler;
});

export default allAutocompletes;
